import React, { useState } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { useSingleItem } from "../_actions/app/items";
import { useItemFine } from "../_actions/app/items";
import { useParams } from "react-router-dom";
import { Button, Typography, Spin, Space, Divider, Avatar } from "antd";
import {
    ArrowLeftOutlined,
    EditOutlined,
    CalendarOutlined,
    UserOutlined,
} from "@ant-design/icons";
import QurealRenderer from "../qureal_renderer/QurealRenderer";
import { history } from "../_helpers/history";
import styles from "./styles/QurealBlog.module.css";

const { Title, Text } = Typography;

function QurealBlogView() {
    // Get blog ID from URL
    const { id } = useParams();
    const [sort, setSort] = useState("date_created");
    const per_page = 10;
    const page_no = 1;

    // Fetch the blog post
    const {
        data: blog,
        isLoading,
        error,
    } = useSingleItem("qblog_posts", `/${id}?fields=*.*`, id !== null);
    console.log(blog);
    const handleEdit = () => {
        history.push(`/ecommerce/blogs/edit/${id}`, {
            from: history.location.pathname,
        });
    };

    const handleBack = () => {
        history.push("/ecommerce/blog");
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading={isLoading ? "Loading..." : "Blog Post"}
                    subtitle={
                        !isLoading && !error && blog
                            ? formatDate(
                                  blog.published_date || blog.date_created
                              )
                            : ""
                    }
                >
                    <Space>
                        <Button
                            icon={<ArrowLeftOutlined />}
                            onClick={handleBack}
                        >
                            Back to Blogs
                        </Button>
                        <Button icon={<EditOutlined />} onClick={handleEdit}>
                            Edit
                        </Button>
                    </Space>
                </SectionHeader>
            }
        >
            {isLoading ? (
                <div className={styles.spinnerContainer}>
                    <Spin size="large" />
                </div>
            ) : error ? (
                <div className={styles.errorContainer}>
                    <Text type="danger">
                        Error loading blog post: {error.message}
                    </Text>
                    <Button onClick={handleBack} style={{ marginTop: 16 }}>
                        Go Back
                    </Button>
                </div>
            ) : blog ? (
                <div className={styles.blogViewContainer}>
                    <article className={styles.blogArticle}>
                        <header className={styles.blogHeader}>
                            <Title level={1} className={styles.blogViewTitle}>
                                {blog.title}
                            </Title>

                            <div className={styles.blogMeta}>
                                <Space>
                                    <Avatar
                                        icon={<UserOutlined />}
                                        src={blog.owner?.avatar}
                                    />
                                    <Text>
                                        {blog.owner?.first_name}{" "}
                                        {blog.owner?.last_name || ""}
                                    </Text>
                                    <Divider type="vertical" />
                                    <Text type="secondary">
                                        <CalendarOutlined />{" "}
                                        {formatDate(
                                            blog.published_date ||
                                                blog.date_created
                                        )}
                                    </Text>
                                </Space>
                            </div>
                        </header>

                        <Divider />

                        <div className={styles.blogContent}>
                            <QurealRenderer content={blog.body} />
                        </div>
                    </article>
                </div>
            ) : (
                <div className={styles.errorContainer}>
                    <Text>Blog post not found</Text>
                    <Button onClick={handleBack} style={{ marginTop: 16 }}>
                        Go Back
                    </Button>
                </div>
            )}
        </QurealSection>
    );
}

export default QurealBlogView;
